export default __webpack_public_path__ + "static/media/reply-naming-conventions1.1a341f9e.png";